module.exports = __webpack_public_path__ + "img/1205188014.c74b2ba8.jpg";